export function milesToMeters(miles: number) {
  return miles * 1609.344;
}

export function milesToKm(miles: number) {
  return miles * 1.60934;
}
